import { NEW_PLACE_TWEAKS_EXPERIMENT } from '@/constants/experimentConstants';
import { useAppSelector } from '@/hooks';
import { useGetAmplitudeExperimentVariant } from '@/hooks/useAmplitudeExperiment';
import ServiceCard from './ServiceCard';
import { ServiceCardProps } from './ServiceCard.types';
import ServiceCardTest from './ServiceCardTest';

const ServiceCardWrapper = (props: ServiceCardProps) => {
  const getVariant = useGetAmplitudeExperimentVariant();
  const flags = useAppSelector((state) => state.flags);
  const placePageTweaksFlag =
    flags[NEW_PLACE_TWEAKS_EXPERIMENT]?.value === 'on' || getVariant(NEW_PLACE_TWEAKS_EXPERIMENT)?.value === 'on';

  return placePageTweaksFlag ? <ServiceCardTest {...props} /> : <ServiceCard {...props} />;
};

export default ServiceCardWrapper;
